<div class="row">
  <div class="col-md-12">
    <div id="mapid" style="height: 70vh; margin-bottom: 10px"> </div>
  </div>
</div>
